import { render } from "./TextEditorBlock.vue?vue&type=template&id=12a5694a&scoped=true"
import script from "./TextEditorBlock.vue?vue&type=script&lang=js"
export * from "./TextEditorBlock.vue?vue&type=script&lang=js"

import "./TextEditorBlock.vue?vue&type=style&index=0&id=12a5694a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-12a5694a"

export default script